
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";

export const useTransactions = (transactionType?: string, period: string = "all", selectedDate?: Date) => {
  return useQuery({
    queryKey: ['transactions', transactionType, period, selectedDate?.toISOString()],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      let query = supabase
        .from('poultry_transactions')
        .select(`
          *,
          stock_items (
            data,
            stock_id
          )
        `)
        .eq('created_by', user.id)
        .order('created_at', { ascending: false });

      if (selectedDate) {
        const dateStr = format(selectedDate, 'yyyy-MM-dd');
        query = query
          .gte('created_at', `${dateStr}T00:00:00`)
          .lte('created_at', `${dateStr}T23:59:59`);
      }

      if (transactionType && transactionType !== "all") {
        query = query.eq('transaction_type', transactionType);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data;
    },
  });
};
